import React from 'react';
import { connect } from 'react-redux';
import { ErrorModal } from '../components/modals/error-modal';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'printEndOfDayWarning.title',
    defaultMessage: 'No Document Available',
    id: 'ttKJUI',
  },
  message: {
    description: 'printEndOfDayWarning.message',
    defaultMessage: 'This End of Day Form has been sent to the carrier electronically. There is no document available to print.',
    id: 'RWGDAR',
  },
  cancel: {
    description: 'printEndOfDayWarning.cancel',
    defaultMessage: 'Cancel',
    id: 'yDZ8UE',
  },
});

const mapStateToProps = (state, props) => {
  const { modalFrameworkMethods } = props;
  return {
    modalFrameworkMethods,
    state: 'warning',
    title: <FormattedMessage {...messages.title} />,
    message: <FormattedMessage {...messages.message} />,
    buttons: [
      {
        children: <FormattedMessage {...messages.cancel} />,
      },
    ],
  };
};

export const PrintEndOfDayWarningContainer = connect(mapStateToProps)(ErrorModal);
